import { Activity } from './Activity'

export type TaskBucket = {
	/** Activity name — same as WorkerActivityResponse.activity / grid Title column */
	activity: string
	/**
	 * Same as WorkerActivityResponse.type:
	 * work-item path ("Parent > … > Activity"), constraint comments, or activity type.
	 */
	type: string
	workItemId?: number | null
	workItemTaskId?: number | null
	reworkId?: number | null
	constraintId?: number | null
	nProgressibleTypeId?: number | null
	hours: number
	percentage: number
}

export type WorkerSummary = {
	workerId: number
	name: string
}

export type SubordinateTaskBreakdown = {
	buckets: TaskBucket[]
	isIncomplete: boolean
	missingWorkers: WorkerSummary[]
	presentCount: number
}

export type ContributorNode = {
	workerId: number
	name: string
	roleTitle: string
	hours: number
	children: ContributorNode[]
}

export type BucketContributors = {
	roots: ContributorNode[]
	totalHours: number
}

export type TimeSheet = {
	id: number
	title: string
	confirmed: boolean
	/** 0 NotApplicable, 1 Pending, 2 Resolved — supervision Direct sheets */
	resolutionStatus?: number
	activities: Activity[]
	signInAt?: Date
	signOutAt?: Date
	localDate?: Date
	workerId?: number
	subordinateTaskBreakdown?: SubordinateTaskBreakdown | null
	unpaidBreakHours?: number
	// calculated upon load:
	startTime?: Date
	endTime?: Date
	hours?: number
}

export enum TimeSheetResolutionStatus {
	NotApplicable = 0,
	Pending = 1,
	Resolved = 2,
}

export enum TimeChanged {
	StartTimeChanged,
	EndTimeChanged,
}
